import Tooltip from "../../../../common/StyledToolTip";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Menu, MenuItem } from "@material-ui/core";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import constants from "./constants";
import { getStopHeaderText } from "./EditStopDialog/util";
const StopActionMenu = ({
  anchorEl,
  handleMenuClose,
  isMarkAsNextStopEnabled,
  isPickupStop,
  handleMenuChange,
  classes,
  enableRemovePro,
  enableAddNotesToPro,
  enableAddProToCompletedPro,
  isCompletedStop,
  isNoFreight,
  isBobTailRoute,
  enableReprocessDelivery,
}) => {
  /* Add pro notes will be enabled in following cases:
    1. Completed stops(Excluding no freight pickup stops)
    2. Pending Delivery stops
    3. No Freight pickup
  */
  const isEnabledAddProNotes = !isNoFreight && (isCompletedStop || !isPickupStop);
  const isEnabledAddProToCompletedPro = !isNoFreight && isCompletedStop;
  const getPickupTooltipText = () => {
    if(isBobTailRoute){
      return 'Hook trailer before processing pickup';
    }else if(isCompletedStop){
      return "Cannot process completed pickup"
    }
    return '';
  }
  return (
    <Menu
      classes={{
        paper: classes.menu,
      }}
      id="stops-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      MenuListProps={{
        "aria-labelledby": "edit",
        disablePadding: true,
      }}
      getContentAnchorEl={null}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      {enableAddNotesToPro && (
        <Tooltip
          title={
            isEnabledAddProNotes
              ? "Add Notes to Pro"
              : "Complete pickup with pros to enable"
          }
          disableFocusListener
        >
          <div>
            <MenuItem
              className={classes.menuItem}
              onClick={() =>
                handleMenuChange(constants.STOPS_MENU_ACTION_LIST.ADD_PRO_NOTES)
              }
              disabled={!isEnabledAddProNotes}
            >
              Add Notes to Pro
            </MenuItem>
          </div>
        </Tooltip>
      )}
      {!isPickupStop && (
        <MenuItem
          className={classes.menuItem}
          disabled={isCompletedStop? !enableReprocessDelivery : false}
          onClick={() =>
            handleMenuChange(constants.STOPS_MENU_ACTION_LIST.PROCESS_DELIVERY)
          }
        >
          {getStopHeaderText(isCompletedStop)}
        </MenuItem>
      )}
      {isPickupStop && (
        <Tooltip
          title={getPickupTooltipText()}
          disableFocusListener>
          <div>
            <MenuItem
              className={classes.menuItem}
              onClick={() => handleMenuChange(constants.STOPS_MENU_ACTION_LIST.PROCESS_PICKUP)}
              disabled={isCompletedStop || isBobTailRoute}>
              Process a pickup
            </MenuItem>
          </div>
        </Tooltip>
      )}
      {!isPickupStop && (
        <MenuItem
          className={classes.menuItem}
          disabled={!enableRemovePro || isCompletedStop}
          onClick={() =>
            handleMenuChange(constants.STOPS_MENU_ACTION_LIST.REMOVE_PRO)
          }
        >
          Remove pro
        </MenuItem>
      )}
      <Tooltip
        title="Driver will be notified to go to this stop next"
        disableFocusListener
      >
        <div>
          <MenuItem
            disabled={!isMarkAsNextStopEnabled || isCompletedStop}
            className={classes.menuItem}
            onClick={() =>
              handleMenuChange(
                constants.STOPS_MENU_ACTION_LIST.MARK_AS_NEXT_STOP
              )
            }
          >
            <span className={classes.markNextStopAction}>
              Mark as next stop
              <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
            </span>
          </MenuItem>
        </div>
      </Tooltip>
      {(enableAddProToCompletedPro && isPickupStop) && (
        <MenuItem
          className={classes.menuItem}
          onClick={() =>
            handleMenuChange(constants.STOPS_MENU_ACTION_LIST.ADD_PRO_TO_PICKUP)
          }
          disabled={!isEnabledAddProToCompletedPro}
        >
          Add Pro to Pickup
        </MenuItem>
      )}
    </Menu>
  );
};

export default withStyles(styles)(StopActionMenu);
